import { ChangeDetectionStrategy, Component, computed, input, signal } from '@angular/core';
import {
  UnitDisplayLedSettings,
  UnitDisplaySettingTypeEnum,
  UnitLEDSettingTypeEnum,
  UnitTimetableSettings,
} from '@cue/api';

@Component({
  selector: 'cue-unit-display-led-setting-info',
  templateUrl: './unit-display-led-setting-info.component.html',
  styleUrl: './unit-display-led-setting-info.component.scss',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class UnitDisplayLedSettingInfoComponent {
  settings = input<UnitDisplayLedSettings | null>(null);

  showDetails = signal(false);

  info = computed(() => {
    const settings = this.settings();
    if (!settings) {
      return null;
    }

    const displaySettingType =
      settings.unitDisplaySettingType === UnitDisplaySettingTypeEnum.PermanentlyOn
        ? 'PermanentlyOn'
        : `AccordingTimetable (${settings.unitDisplayTimeTable?.name || 'unnamed'})`;

    let ledSettingType = 'PermanentlyOn';
    if (settings.unitSideLEDIndicationSettingType === UnitLEDSettingTypeEnum.PermanentlyOff) {
      ledSettingType = 'PermanentlyOff';
    } else if (settings.unitSideLEDIndicationSettingType === UnitLEDSettingTypeEnum.AccordingTimetable) {
      ledSettingType = `AccordingTimetable (${settings.unitSideLEDIndicationTimeTable?.name || 'unnamed'})`;
    }

    return {
      summary: `Display: ${displaySettingType} | LED: ${ledSettingType}`,
      displayDetail: this.formatTimetableSlots(settings.unitDisplayTimeTable),
      ledDetail: this.formatTimetableSlots(settings.unitSideLEDIndicationTimeTable),
    };
  });

  protected toggleDetails() {
    this.showDetails.update((value) => !value);
  }

  private formatTimetableSlots(timetable?: UnitTimetableSettings | null) {
    const dayNames = ['Mon', 'Tue', 'Wed', 'Thu', 'Fri', 'Sat', 'Sun'];
    const slots = (timetable?.timeTableSettings || [])
      .filter((slot) => slot.periodStart && slot.periodEnd)
      .sort((a, b) => a.day - b.day)
      .map((slot) => `${dayNames[slot.day] ?? `Day ${slot.day}`}: ${slot.periodStart}-${slot.periodEnd}`);

    return slots.length > 0 ? slots.join(' | ') : null;
  }
}
